import { render, staticRenderFns } from "./IconSnapchat.vue?vue&type=template&id=31e15f62&"
import script from "./IconSnapchat.vue?vue&type=script&lang=js&"
export * from "./IconSnapchat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports